import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-bold-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="currentColor"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M11.9996 12.5003H7.2529C6.9796 12.5003 6.7529 12.2737 6.7529 12.0003V7.00033C6.7529 5.98699 7.5729 5.16699 8.5863 5.16699H11.9996C14.0196 5.16699 15.6663 6.81366 15.6663 8.83366C15.6663 10.8537 14.0196 12.5003 11.9996 12.5003ZM7.7463 11.5003H11.9996C13.4729 11.5003 14.6663 10.307 14.6663 8.83366C14.6663 7.36033 13.4729 6.16699 11.9996 6.16699H8.5863C8.1263 6.16699 7.7529 6.54033 7.7529 7.00033V11.5003H7.7463Z" />
      <path
        d="M13.5863 18.8333H8.5863C7.5729 18.8333 6.7529 18.0133 6.7529 17V12C6.7529 11.7267 6.9796 11.5 7.2529 11.5H13.5863C15.6063 11.5 17.2529 13.1467 17.2529 15.1667C17.2529 17.1867 15.6063 18.8333 13.5863 18.8333ZM7.7463 12.5V17C7.7463 17.46 8.1196 17.8333 8.5796 17.8333H13.5796C15.0529 17.8333 16.2463 16.64 16.2463 15.1667C16.2463 13.6933 15.0529 12.5 13.5796 12.5H7.7463Z" />
    </svg>
  `,
})
export class BoldIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 24 24');
}
